var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3957)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_1_3957)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1194 9.36415H10.8791C10.042 9.36415 9.3634 10.0427 9.3634 10.8798V19.1201C9.3634 19.9572 10.042 20.6358 10.8791 20.6358H19.1194C19.9565 20.6358 20.635 19.9572 20.635 19.1201V10.8798C20.635 10.0427 19.9565 9.36415 19.1194 9.36415ZM13.847 11.6386H11.9682C11.7324 11.6386 11.5411 11.8298 11.5411 12.0657V17.5235C11.5411 17.7594 11.7324 17.9507 11.9682 17.9507H13.847C14.0829 17.9507 14.2741 17.7594 14.2741 17.5235V12.0657C14.2741 11.8298 14.0829 11.6386 13.847 11.6386ZM16.1518 11.6386H18.0306C18.2665 11.6386 18.4577 11.8298 18.4577 12.0657V15.0189C18.4577 15.2547 18.2665 15.446 18.0306 15.446H16.1518C15.916 15.446 15.7247 15.2547 15.7247 15.0189V12.0657C15.7247 11.8298 15.916 11.6386 16.1518 11.6386Z",
    fill: "#1E202A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3957",
    x1: 0,
    y1: 0,
    x2: 35.5334,
    y2: 9.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.9c9fd41d.svg";
export { ForwardRef as ReactComponent };